<template>
  <div class="home" v-loading="loading">
    <div class="header">
      <!-- 搜索区域 -->
      <div class="search">
        <el-table
          :data="tableData"
          border
          style="width: 100%; cursor: pointer"
          :header-cell-style="{
            color: '#333333',
            backgroundColor: '#FAFAFA',
          }"
        >
          <el-table-column label="简介" width="340">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.intro }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系方式" width="180">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.phone }}</span>
            </template>
          </el-table-column>
          <el-table-column label="版权有效申明">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.copyright1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="版权" width="220">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.copyright2 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最后编辑id名称">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.admin_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="198">
            <template slot-scope="scope">
              <div class="table-operation" @click="compileBtn(scope.row)">
                编辑
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--第二区域添加 弹出框-->
    <div class="addBlock">
      <el-dialog
        :visible.sync="compileDialogVisible"
        width="532px"
        style="margin-top: 10vh"
        @close="addClose"
      >
        <span slot="footer" class="dialog-footer">
          <div class="addBlock-div">
            <div class="addBlock-div-top">
              <div class="addBlock-div-top-title">编辑</div>
              <img
                class="addBlock-div-top-close"
                src="../../assets/common/close.png"
                @click="addClose"
              />
            </div>

            <div class="addBlock-div-center">
              <div class="center-header">
                <div class="center-header-left">
                  <div class="center-header-title">简介</div>
                  <div class="center-header-input">
                    <el-input
                      placeholder="请输入简介"
                      v-model="compileSynopsis"
                      clearable
                    ></el-input>
                  </div>
                </div>

                <div class="center-header-right">
                  <div class="center-header-title">联系方式</div>
                  <div class="center-header-input">
                    <el-input
                      placeholder="请输入联系方式"
                      v-model="compileRelation"
                      clearable
                    ></el-input>
                  </div>
                </div>
              </div>

              <div class="center-conversion">
                <div class="conversion-title">内容</div>
                <div class="conversion-input">
                  <el-input
                    type="textarea"
                    placeholder="请输入版权有效声明"
                    v-model="compileCopyrightValid"
                    maxlength=""
                    show-word-limit
                  ></el-input>
                </div>
              </div>

              <div class="center-conversion">
                <div class="conversion-title">版权</div>
                <div class="conversion-input">
                  <el-input
                    placeholder="请输入版权"
                    v-model="compileCopyright"
                    clearable
                  ></el-input>
                </div>
              </div>
            </div>

            <div class="addBlock-div-button">
              <!-- <div class="addBlock-div-button-left" @click="addClose">
                重 置
              </div> -->
              <div class="addBlock-div-button-right" @click="addConfirm">
                确 定
              </div>
            </div>
          </div>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getaboutDetail, postaboutDetail } from '../../api/common'

export default {
  comments() {},
  data() {
    return {
      // 编辑 弹出框  是否开启
      compileDialogVisible: false,
      // 编辑 弹出框  简介
      compileSynopsis: '',
      // 编辑 弹出框  联系方式
      compileRelation: '',
      // 编辑 弹出框  版权有效声明
      compileCopyrightValid: '',
      // 编辑 弹出框  版权
      compileCopyright: '',

      /* end */
      tableData: [],
      // 刷新
      loading: false,
      // 控制当前页面功能性按钮开关
      basicFunShow: false,
    }
  },
  created() {
    // 获取关于我们详情
    this.loading = true
    this.getAbout()

    setTimeout(() => {
    this.basicFunShow = this.$store.state.pageFunctionShow

    }, 1000);
  },
  methods: {
    // 获取关于我们详情
    getAbout() {
      let params = {}

      getaboutDetail(params).then((res) => {
        if (res.resultStatus == true) {
          // 获取数据
          this.tableData = []
          this.tableData.push(res.resultData)
          this.loading = false
        }
      })
    },

    compileBtn(item) {
      if (this.basicFunShow == false) {
        return
      }

      this.compileSynopsis = item.intro
      this.compileRelation = item.phone
      this.compileCopyrightValid = item.copyright1
      this.compileCopyright = item.copyright2

      this.compileDialogVisible = true
    },
    // 添加按钮 蒙层  重置
    addClose() {
      this.compileSynopsis = ''
      this.compileRelation = ''
      this.compileCopyrightValid = ''
      this.compileCopyright = ''
      this.compileDialogVisible = false
    },

    // 添加按钮 确认
    addConfirm() {
      let params = {
        intro: this.compileSynopsis,
        phone: this.compileRelation,
        copyright1: this.compileCopyrightValid,
        copyright2: this.compileCopyright,
      }

      postaboutDetail(params).then((res) => {
        if (res.resultStatus == true) {
          this.$message({
            message: '修改成功！',
            type: 'success',
          })
          this.loading = true
          this.compileDialogVisible = false
          this.getAbout()
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .el-input__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-textarea__inner:focus {
  border-color: rgba(217, 217, 217, 1);
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: rgba(255, 255, 255, 0);
}

.home {
  margin: 0 auto;
  background-color: #f4f5f9;
}
.header {
  min-height: 900px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px #edeff7;
  border-radius: 10px;
}
.search {
  padding: 24px;
  box-sizing: border-box;

  /deep/ .el-table thead {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #333333;
    background: #d8d8d8;
  }

  /deep/ .el-table .el-table__cell {
    vertical-align: top;
  }

  /deep/ .el-table tr {
    height: 46px;
  }

  /deep/ .el-table__empty-text {
    line-height: 0;
  }

  .table-operation {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2aa4ff;
    text-decoration: underline;
  }
}
/* 添加弹出框 */
.addBlock {
  /deep/ .el-dialog__footer {
    padding: 0;
    text-align: left;
  }

  /deep/ .el-dialog {
    height: 394px;
    border-radius: 10px !important;
  }
  .addBlock-div {
    background: #ffffff;
    border-radius: 10px;

    .addBlock-div-top {
      display: flex;
      height: 56px;
      align-items: center;
      justify-content: space-between;
      padding: 0 24px;
      box-sizing: border-box;
      border-bottom: 1px solid #e9edf4;
      .addBlock-div-top-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #222222;
      }
      .addBlock-div-top-close {
        width: 10px;
        height: 10px;
        cursor: pointer;
      }
    }

    .addBlock-div-center {
      padding: 20px 24px 0;
      box-sizing: border-box;
      .center-header {
        display: flex;
        justify-content: space-between;

        .center-header-left,
        .center-header-right {
          .center-header-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }

          .center-header-input {
            height: 32px;
            background: #ffffff;
            border-radius: 5px;
            margin-top: 4px;

            /deep/ .el-input {
              width: 214px;
              height: 32px;
            }

            /deep/ .el-input__inner {
              padding: 0 10px;
              box-sizing: border-box;
              height: 32px;
              background-color: rgba(255, 255, 255, 0);
            }
          }
        }
      }

      .center-conversion {
        margin-top: 16px;

        .conversion-title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }

        .conversion-input {
          /deep/ .el-input {
            height: 32px;
          }

          /deep/ .el-input__inner {
            padding: 0 10px;
            box-sizing: border-box;
            height: 32px;
            background-color: rgba(255, 255, 255, 0);
          }

          /deep/ .el-textarea {
            height: 88px;
            cursor: pointer;
          }

          /deep/ .el-textarea__inner {
            height: 88px;
            padding: 10px 10px 20px;
          }

          /deep/ .el-textarea .el-textarea__inner {
            // 然后找到对应的类名，在这里将拉伸去掉即可
            resize: none;
          }
        }
      }
    }

    .addBlock-div-button {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 24px;
      box-sizing: border-box;
      height: 52px;
      border-top: 1px solid #e9edf4;
      margin-top: 25px;

      .addBlock-div-button-left,
      .addBlock-div-button-right {
        width: 65px;
        height: 32px;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid #e9edf4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
      }

      .addBlock-div-button-right {
        background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
        margin-left: 8px;
        color: #ffffff;
      }
    }
  }
}
</style>
